<template>
  <div>
    <div class="page" :class="{'ratio': devicePixelRatio === 2}">
      <div class="title"><p>Lending License</p></div>
      <div class="content">
        <p><span>EXQUISITE SHOWERS LIMITED</span>,a duly registered and licensed financial institution under the laws of the Republic Nigeria,
          with company registration number 8030217, and registered address at 8 SHANU STREET OFF AFARIOGUN, IKEJA, LAGOS STATE.
          We offers an inventive, consistent and quick way to deal with customer loan products, enabling us to adjust to your changing needs - serving you with high business morals and transparency.</p>
        <div class="certificate">
          <p>Money Lender’s Certificate</p>
          <img src="../assets/img/Lender.png" alt="">
        </div>
        <div class="certificate">
          <p>FCCPC waiver letter</p>
          <img class="fccpc" src="../assets/img/fccpc_cer.png" alt="">
        </div>
        <div class="certificate">
          <p>SCUML’s Certificate </p>
          <img class="approve" src="../assets/img/SCUML.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ContactUs',
  data() {
    return {
      devicePixelRatio: window.devicePixelRatio,
      loading: false,
      form: {
        name: '',
        email: '',
        subject: '',
        content: '',
        type: '',
      },
      rules: {
        name: { required: true, message: 'Please enter', trigger: 'change' },
        email: { required: true, message: 'Please enter', trigger: 'change' },
        subject: { required: true, message: 'Please enter', trigger: 'change' },
        content: { required: true, message: 'Please enter', trigger: 'change' },
        type: { required: true, message: 'Please select', trigger: 'change' },
      },
    };
  },
  methods: {
    async onSubmit() {
      const valid = await this.$refs.form.validate();
      if (!valid) return;
      this.loading = true;
      /*
      await this.$axios
        .post(contactUs, this.form)
        .then((e) => {
          if (e.status.code === '000') {
            this.$refs.form.resetFields();
            this.$message({
              message: e.status.msg,
              type: 'success',
            });
          } else {
            this.$message.error(e.status.msg);
          }
        })
        .catch(() => {}); * */
      this.$message({
        message: 'submit success!',
        type: 'success',
      });
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@mixin pixel-ratio() {}

.page {
  @include pixel-ratio();
  /deep/ .el-button--primary {
    color: #FFFFFF;
    background-color: #97c901;
    border-color: #97c901;
  }

  width: 100%;
  height: 100vh;
  margin: 0 auto;

  @media screen and (min-width: 900px) {
    min-width: 1280px;
    max-width: 1280px;
    padding-top: 40px;
    margin-bottom: 50px;
  }

  @media screen and (max-width: 900px) {
    min-width: 0;
    max-width: 100vw;
    padding: 20px;
    margin-bottom: 20px;
  }
  .title {
    margin-top: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 36px;
    font-weight: bolder;
    width: 100%;
    min-height: 10vh;
    max-height: 10vh;
    @media screen and (max-width: 900px) {
      min-height: 10vh;
      max-height: 20vh;
    }
  }

  .content {
    padding-bottom: 50px;

    @media screen and (min-width: 900px) {
      margin-top: 20px;
    }

    @media screen and (max-width: 900px) {
      margin-top: 20px;
    }

    .certificate{
      padding-top: 30px;
      text-align: center;
      p {
        text-align: center;
      }
      img {
        width: 60%;
        // max-height: 600px;
      }
      .fccpc{
        width: 60%;
      }
      .approve {
        width: 80%;
      }
    }

    h1 {
      font-size: 30px;
      font-weight: bolder;
      text-align: center;
      margin-bottom: 20px;
    }

    p {
      font-size: 15px;
      line-height: 22px;
      margin-bottom: 10px;
      text-align: justify;
    }

    h2 {
      font-size: 22px;
      line-height: 30px;
      font-weight: bold;
      margin: 35px 0 20px 0;
    }
    span {
      font-weight: bold;
    }
  }
  .block1 {
    text-align: left;
    .block_box {
      display: flex;
    }
    .title {
      font-size: 32px;
      font-weight: 700;
      color: #333333;
    }
    .text {
      font-size: 14px;
      color: #333333;
      padding: 10px 0px;
    }
    .hint {
      font-size: 13px;
      color: #999999;
      padding: 10px 0px;
    }
    .el-button {
      margin-top: 30px;
    }
    &_box {
      max-width: 1200px;
      margin: 0 auto;
    }
    &.bar {
      background: #FBF9F9;
      .block_box {
        position: relative;
      }
      .bar_img {
        background-size: contain;
        background-repeat: no-repeat;
        background-position: right;
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 0;
      }
      .bar_content {
        position: relative;
        z-index: 1;
        padding: 10px;
        flex: 1;
        padding-top: 100px;
        padding-bottom: 40px;
        max-width: 600px;
        .licensed {
          font-size: 14px;
          color: #999999;
          margin-top: 10px;
          &_logo {
            background: url("../assets/img/fccpc.png") no-repeat;
            background-size: auto 30px;
            width: 50px;
            height: 30px;
            display: inline-block;
            vertical-align: middle;
            margin-right: 5px;
          }
        }
      }
    }
    &.prompt {
      margin-top: 40px;
      .block_box {
        padding: 10px;
      }
    }
    &.over {
      margin-top: 64px;
      .over_content {
        padding: 10px;
        padding-top: 55px;
        flex: 1;
      }
      .over_img {
        width: 295px;
        height: 295px;
        background-size: 100%;
        background-repeat: no-repeat;
        text-align: center;
        position: relative;
        >div {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: white;
          font-size: 21px;
          span {
            font-size: 14px;
            color: #F0ECF5;
          }
          div {
            font-size: 47px;
            font-weight: bold;
          }
        }
      }
    }
    &.ready {
      margin-top: 64px;
      margin-bottom: 64px;
      .ready_content {
        padding: 10px;
        padding-top: 55px;
        flex: 1;
        text-align: right;
      }
      .ready_img {
        max-width: 396px;
        img {
          width: 100%;
        }
      }
    }
  }
  .block {
    text-align: left;
    .title {
      font-size: 32px;
      font-weight: 700;
      color: #333333;
    }
    .text {
      font-size: 14px;
      color: #333333;
      padding: 10px 0px;
    }
    .hint {
     font-size: 13px;
     color: #333333;
     padding: 10px 0px;
    }
    .line {
      height: 0.5px;
      background: #CCCCCC;
    }
    .el-button {
      margin-top: 30px;
    }
    .el-form-item {
      display: inline-block;
    }
    &_box {
      max-width: 1200px;
      margin: 0 auto;
    }
    &.bar {
      position: relative;
      background: white;
      .bar_img {
        width: 100%;
        img {
          width: 100%;
        }
      }
      .bar_content {
        position: absolute;
        z-index: 2;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        .bar_value {
          position: relative;
          top: 50%;
          transform: translateY(-50%);
          padding: 0px 10px;
          max-width: 1200px;
          margin: 0 auto;
          .hint {
            max-width: 500px;
          }
        }
      }
    }
    &.form {
      margin-top: 40px;
      .block_box {
        padding: 10px;
      }
      .form_content {
        text-align: center;
        padding: 20px;
        .input {
          display: inline-block;
          width: 100%;
          text-align: center;
          span {
            min-width: 155px;
            display: inline-block;
            text-align: right;
            font-size: 12px;
            color: #666666;
          }
          .el-input {
            vertical-align: middle;
            margin-left: 10px;
            width: 400px;
          }
          .el-textarea {
            width: 400px;
            vertical-align: top;
            margin-left: 4px;
          }
          .radio {
            display: inline-block;
            width: 400px;
            vertical-align: top;
            text-align: left;
            .el-radio {
              display: block;
              text-align: left;
              margin-bottom: 12px;
            }
          }
        }
        .el-button {
          min-width: 350px;
          margin-top: 40px;
        }
      }
    }

  }

  @media screen and (max-width: 800px) {
    .block {
      text-align: center;
      .block_box {
        display: inline-block;
      }
      .el-form-item {
        display: block;
      }
      &.bar {
        min-height: 600px;
        .bar_img {
          position: absolute;
          top: 150px;
          bottom: 0px;
          left: 0px;
          right: 0px;
          &::before {
            content: "";
            position: absolute;
            z-index: 1;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-image: linear-gradient(0deg,rgba(0,0,0,0.00)0%,#ffffff 100%);
          }
          img {
            height: 100%;
            width: auto;
            position: absolute;
            right: 0px;
            transform: translateX(22%);
          }
        }
        .title {
          font-size: 26px;
        }
        .el-button {
          position: absolute;
          bottom: 28px;
          left: 50%;
          transform: translateX(-50%);
        }
        .bar_content {
          padding-top: 30px;
          padding-bottom: 20px;
          .bar_value {
            position: initial;
            top: 10px;
            transform: none;
          }
        }
      }

      &.form {
        .form_content {
          margin-top: 0px;
          padding: 0px 10px;
          padding-top: 20px;
          padding-bottom: 30px;
          .input {
            width: 100%;
            padding: 0px;
            text-align: left;
            span {
              text-align: left;
              margin-bottom: 8px;
            }
            .el-input {
              margin-left: 0px;
              width: 100%;
            }
            .el-textarea {
              margin-left: 0px;
              width: 100%;
            }
            .radio {
              margin-left: 0px;
              width: 100%;
            }
          }
          .el-button {
            min-width: 80%;
            margin-top: 40px;
          }
        }
      }

    }
  }
}
</style>
